
export function resolveIPFS(url: string | undefined): string | undefined {
  return url
    ?.replace(/^ipfs:\/\/ipfs\//, "https://ipfs.io/ipfs/")
    ?.replace(/^ipfs:\/\//, "https://ipfs.io/ipfs/");
}